import { FC, useEffect, useMemo, useState, useTransition } from "react";

import { useDropdownSourceContext } from "@ryde/redux";
import { FIELD_TYPE_IDS } from "@ryde/shared";

import { FramerTooltip } from "../../common";
import { useDecorateWithMark } from "../../utils";
import { IRenderColumnTemplate } from "./_core";

export const DropdownBoundTextCellTemplate: FC<IRenderColumnTemplate> = ({
  value,
  e2eData,
  formAttributes,
  gridAttributes,
  formFieldTypeId,
  isColumn,
}) => {
  const { decorateValue } = useDecorateWithMark();
  const { getDropdownLabel } = useDropdownSourceContext();
  const [displayValue, setDisplayValue] = useState<string>(String(value || ""));
  const [, startTransition] = useTransition();

  const highlightedValue = useMemo(() => {
    return decorateValue(displayValue);
  }, [displayValue, decorateValue]);

  useEffect(() => {
    const getItems = async (): Promise<void> => {
      if (formAttributes?.dropItemsSource) {
        const label = await getDropdownLabel(
          formAttributes.dropItemsSource,
          value,
        );
        setDisplayValue(label);
      }
    };

    if (formFieldTypeId === FIELD_TYPE_IDS.FORM.dropdown_bound) {
      startTransition(() => {
        getItems();
      });
    }
  }, [
    value,
    formFieldTypeId,
    isColumn,
    gridAttributes?.fieldNameGrid,
    formAttributes?.dropItemsSource,
    getDropdownLabel,
  ]);

  return (
    <div
      className="cell_simple"
      data-e2e-custom={e2eData}
      data-e2e-type="dropdown-bound-cell-template"
    >
      <FramerTooltip content={displayValue} rtlStrippedBottomLeftPlacement>
        <span>{highlightedValue}</span>
      </FramerTooltip>
    </div>
  );
};
